import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/hackzurich2022-swissre-challenge/hackzurich2022-swissre-challenge/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Expertise in the face of risk`}</h1>
    <p>{`Now more than ever, our clients need to deal with the world as it is, not as it used to be. We work withour clients in new and innovative ways to identify and prevent the toughest risks across the globe. We do so thanks to our holistic risk engineering approach, which combines expertise with pragmatism. Just as importantly, we’re backed by the financial strength of Swiss Re.`}</p>
    <h2>{`Value beyond risk transfer`}</h2>
    <p>{`Our tailored risk insights combine global and industry specific expertise with powerful data & analytics to help our customers manage risks, advance their business and build a more sustainable future.`}</p>
    <ul>
      <li parentName="ul">{`Powerful global analytics for forward looking risk management`}</li>
      <li parentName="ul">{`Flexible and collaborative approach designed to suit customers’ needs, delivering standard and tailored services`}</li>
      <li parentName="ul">{`Out-of-the-box brainstorming & ideation, Property and NatCat assessments`}</li>
      <li parentName="ul">{`Deep industry expertise, providing loss prevention and procedural standards to promote risk improvement`}</li>
      <li parentName="ul">{`Risk Insights to control and shape the risk landscape, combining customer’s expertise with our technical knowledge`}</li>
    </ul>
    <p>{`Want to learn more? Talk to us on the HackZurich or on Discord and visit our website: `}<a href="https://corporatesolutions.swissre.com/insurance-solutions/services/risk-engineering-services.html" target="_blank" rel="noreferrer">{`Risk Engineering Services | Insurance Solutions | Swiss Re`}</a></p>
    <undefined><div {...{
        "className": "flex flex-col text-left items-start w-full space-y-3 pt-10"
      }}>{`
  `}<img parentName="div" {...{
          "src": "https://media-exp1.licdn.com/dms/image/C4E03AQGaRPjf6raRRQ/profile-displayphoto-shrink_800_800/0/1558061050742?e=1667433600&v=beta&t=79iV3v6reL7dsxR8B6LgN8Y2pyHTkhDLxRotEZY0oqM",
          "alt": "Anup Roy",
          "width": 130,
          "height": 130,
          "className": "rounded-full"
        }}></img>{`
  `}<span parentName="div" {...{
          "className": "text-lg font-semibold"
        }}>{`
    Anup Roy 
    `}<a parentName="span" {...{
            "className": "linkedin",
            "target": "_blank",
            "rel": "noreferrer",
            "href": "https://www.linkedin.com/in/anupkumarroy/"
          }}></a>{`
     `}<a parentName="span" {...{
            "className": "discord-sm",
            "target": "_blank",
            "rel": "noreferrer",
            "href": "https://discord.com/channels/987004253711245342/1011653629792493579"
          }}></a>{`
  `}</span>{`
  `}<span parentName="div" {...{
          "className": "text-sm"
        }}>{`
    Global Manager Risk Engineering Services Natural Hazards
  `}</span>{`
  `}<p parentName="div">{`
    I'm Anup Roy, a senior risk engineer with Swiss Re for more than 10 years,
    currently heading the global natural hazards risk engineering team. Swiss Re
    has given me great opportunities and challenges to impact various
    areas/industries like oil & gas, chemicals, general property, natural
    hazards and cyber. Our team comprises of subject matter experts who provide
    Natural Catastrophe related risk engineering insights/tools to make our
    clients aware of the risks and help them take necessary actions to mitigate.
    In this journey along with our clients, our company empowers individuals to
    identify complex problems and execute one's pragmatic ideas to make the
    world more resilient.
  `}</p>
      </div>
      <div {...{
        "className": "flex flex-col text-left items-start w-full space-y-3 pt-10"
      }}>{`
  `}<img parentName="div" {...{
          "src": "https://media-exp1.licdn.com/dms/image/C4D03AQHQaOEVS1PgeQ/profile-displayphoto-shrink_800_800/0/1611644050547?e=1668643200&v=beta&t=DMXupgJWDlzPeIPK6h0iqLmSI7YDuMxkEpzVJk1pCSA",
          "alt": "Kenishia Naidoo",
          "width": 130,
          "height": 130,
          "className": "rounded-full"
        }}></img>{`
  `}<span parentName="div" {...{
          "className": "text-lg font-semibold"
        }}>{`
    Kenishia Naidoo 
    `}<a parentName="span" {...{
            "className": "linkedin",
            "target": "_blank",
            "rel": "noreferrer",
            "href": "https://www.linkedin.com/in/kenishia-naidoo-99901255/"
          }}></a>{` 
    `}<a parentName="span" {...{
            "className": "discord-sm",
            "target": "_blank",
            "rel": "noreferrer",
            "href": "https://discord.com/channels/987004253711245342/1011653629792493579"
          }}></a>{`
  `}</span>{`
  `}<span parentName="div" {...{
          "className": "text-sm"
        }}>{`Risk Engineer`}</span>{`
  `}<p parentName="div">{`
    I am Kenishia - a risk engineer with Swiss Re. I am based in South Africa
    having joined the organization 1 year ago. With close to ten years
    experience in the field - my gratification comes from the ever changing
    environment that opens doors to continuous learning opportunities. The only
    constant in the world is CHANGE.
  `}</p>
      </div>
      <div {...{
        "className": "flex flex-col text-left items-start w-full space-y-3 pt-10"
      }}>{`
  `}<img parentName="div" {...{
          "src": "https://raw.githubusercontent.com/faxg/hackzurich2022-swissre-challenge/master/static/images/team_YA.jpg",
          "alt": "Youssef Azzaoui",
          "width": 130,
          "height": 130,
          "className": "rounded-full"
        }}></img>{`
  `}<span parentName="div" {...{
          "className": "text-lg font-semibold"
        }}>{`
    Youssef Azzaoui 
    `}<a parentName="span" {...{
            "className": "discord-sm",
            "target": "_blank",
            "rel": "noreferrer",
            "href": "https://discord.com/channels/987004253711245342/1011653629792493579"
          }}></a>{`
  `}</span>{`
  `}<span parentName="div" {...{
          "className": "text-sm"
        }}>{`Risk Engineer`}</span>{`
  `}<p parentName="div">{`
    Hi, I am Youssef, Risk engineer at SwissRe. Originally from Morocco, I am
    now based in Paris. My biggest fear was to stop learning, then I joined
    SwissRe : the most dynamic innovators and challenging insurance company.
    Today, I am a mechanical engineer, attending the Hackzurich and working on
    AI projects
  `}</p>
      </div>
      <div {...{
        "className": "flex flex-col text-left items-start w-full space-y-3 pt-10"
      }}>{`
  `}<img parentName="div" {...{
          "src": "https://media-exp1.licdn.com/dms/image/C4E03AQHn1wjno_F7hA/profile-displayphoto-shrink_800_800/0/1553261217116?e=1668038400&v=beta&t=F6QV1eZOZAXMHbEkJwXMbpCP-ajMvcJsmwhrrQf9og8",
          "alt": "Philip Brandl",
          "width": 130,
          "height": 130,
          "className": "rounded-full"
        }}></img>{`
  `}<span parentName="div" {...{
          "className": "text-lg font-semibold"
        }}>{`
    Philip Brandl 
    `}<a parentName="span" {...{
            "className": "linkedin",
            "target": "_blank",
            "rel": "noreferrer",
            "href": "https://www.linkedin.com/in/philip-brandl-4828015b/"
          }}></a>{` 
    `}<a parentName="span" {...{
            "className": "discord-sm",
            "target": "_blank",
            "rel": "noreferrer",
            "href": "https://discord.com/channels/987004253711245342/1011653629792493579"
          }}></a>{`
  `}</span>{`
  `}<span parentName="div" {...{
          "className": "text-sm"
        }}>{`Head Risk Engineering Services EMEA`}</span>{`
  `}<p parentName="div" {...{
          "className": "text-lg"
        }}>{`
    "borders are great - they really energize me when I step over them!"
  `}</p>{`
  `}<p parentName="div">{`
    I am Philip, a risk engineer, senior leader and innovator. I joined Swiss Re
    10 years ago and built-up our EMEA team of risk engineers, the most diverse,
    talented and fun group of people I have ever worked with. I am fascinated by
    people, especially young talents and by solving our customers' problems, by
    first understanding them and helping build a proper problem statement. I am
    fascinated, even after 10 years as Swiss Re's mission to make the world more
    resilient gives me true purpose, a challenging environment to grow and learn
    new things and enable others to grow. The direct access to the Corporate
    world and today's speed of transformation provide an abundance of
    opportunities to choose from. @RISKEngineering, we help create value beyond
    risk transfer.
  `}</p>{`
  `}<p parentName="div">{`Meet Philip at the HackZurich onsite!`}</p>{`
  `}<img parentName="div" {...{
          "src": "https://raw.githubusercontent.com/faxg/hackzurich2022-swissre-challenge/master/static/images/team_pb_qr.png",
          "alt": "Risk Eng QR",
          "width": 150,
          "height": 186
        }}></img>
      </div></undefined>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      